import { Directive, ElementRef, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[showPassword]'
})
export class ShowPasswordDirective implements OnInit, OnDestroy {
  static readonly DEFAULT_CLASS = 'password-eye';  // default styles in _password.scss

  private _hide = true;
  private icon: HTMLElement;
  private clickListener = this.toggle.bind(this);

  constructor(private elementRef: ElementRef<HTMLInputElement>) { }

  ngOnInit() {
    this.init();
  }

  ngOnDestroy() {
    this.removeEventListeners();
  }

  init() {
    const parent = this.elementRef.nativeElement.parentNode;
    this.icon = document.createElement('i');
    this.icon.classList.add(ShowPasswordDirective.DEFAULT_CLASS);
    this.icon.classList.add('icon-eye-on');
    this.icon.addEventListener('click', this.clickListener);
    parent.appendChild(this.icon);
  }

  toggle() {
    this._hide = !this._hide;

    let newIconName = 'icon-eye-off';
    let previousIconName = 'icon-eye-on';
    let passwordType = 'text';

    if (this._hide) {
      newIconName = 'icon-eye-on';
      previousIconName = 'icon-eye-off';
      passwordType = 'password';
    }

    this.elementRef.nativeElement.setAttribute('type', passwordType);
    this.icon.classList.add(newIconName);
    this.icon.classList.remove(previousIconName);
  }

  removeEventListeners() {
    this.icon.removeEventListener('click', this.clickListener);
  }
}
